import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'

//import $ from "expose-loader?exposes=$,jQuery!jquery";

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

const vues = document.querySelectorAll(".sus_lodging_search_bar");
const each = Array.prototype.forEach;



each.call(vues, function (el, index)
{
    var data = {
        action:  el.getAttribute('action'),
        identifier: el.getAttribute('data-identifier'),
        store_id: el.getAttribute('data-store_id'),
        dest_id: el.getAttribute('data-dest_id'),
        venue_id: el.getAttribute('data-venue_id'),
        lodging_id: el.getAttribute('data-lodging_id'),
        lodging_sku_id: el.getAttribute('data-lodging_sku_id'),
        adults: el.getAttribute('data-adults'),
        children: el.getAttribute('data-children'),
        min_days: el.getAttribute('data-min_days'),
    }

    new Vue({
        data:   data,
        render: h => h(App),
    }).$mount(el)
})
